import { render } from "./CreateCollection.vue?vue&type=template&id=437c7213&scoped=true"
import script from "./CreateCollection.vue?vue&type=script&lang=js"
export * from "./CreateCollection.vue?vue&type=script&lang=js"

import "./CreateCollection.vue?vue&type=style&index=0&id=437c7213&scoped=true&lang=css"

import exportComponent from "C:\\Users\\brettp\\Documents\\Workspaces\\dealer-portal\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-437c7213"]])

export default __exports__